export const blockIconsHomeNestMultiRoomNew = (
	<span className='material-symbols-outlined'>nest_multi_room</span>
);
